// frontend/app/exhibit/v2/screens/AudienceScreen.js

import React from "react";
import { Pressable, StyleSheet, View } from "react-native";
import { LocalizedText as Text } from "../i18n/ExhibitLocaleContext";

import { tx } from "../i18n/exhibitLocale";

const TIERS = [
  {
    key: "el",
    icon: "🧒",
    label: "Elementary school",
    sub: "about ages 6 to 10",
  },
  {
    key: "ms",
    icon: "🧑",
    label: "Middle school",
    sub: "about ages 11 to 13",
  },
  {
    key: "hs",
    icon: "🧑‍🎓",
    label: "High school & adults",
    sub: "ages 14 and up",
  },
];

export default function AudienceScreen({
  language = "en",
  onSelect = () => {},
  onSkip = () => {},
}) {
  return (
    <View style={styles.container}>
      <View style={styles.topBar}>
        <Text style={styles.brand}>{tx(language, "Who's playing?")}</Text>
      </View>

      <View style={styles.content}>
        <Text style={styles.eyebrow}>{tx(language, "ONE QUICK QUESTION")}</Text>

        <Text style={styles.title}>{tx(language, "Who's playing?")}</Text>

        <Text style={styles.subtitle}>
          {tx(language, "We’ll adjust the wording and explanation depth for your age group. The activities stay the same.")}
        </Text>

        <View style={styles.row}>
          {TIERS.map((tier) => (
            <Pressable
              key={tier.key}
              onPress={() => onSelect(tier.key)}
              style={({ pressed }) => [
                styles.tile,
                pressed && styles.tilePressed,
              ]}
            >
              <Text style={styles.icon}>{tier.icon}</Text>

              <Text style={styles.label}>
                {tx(language, tier.label)}
              </Text>

              <Text style={styles.sub}>
                {tx(language, tier.sub)}
              </Text>
            </Pressable>
          ))}
        </View>

        <Pressable onPress={onSkip} style={styles.skip}>
          <Text style={styles.skipText}>{tx(language, "skip →")}</Text>
        </Pressable>
      </View>

      <View style={styles.footer}>
        <Text style={styles.footerText}>
          {tx(language, "Your pick adjusts the wording, explanation depth, and Ask Saras answer level for this exhibit session · no birthdate is requested · the exhibit asks again for the next visitor")}
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: 1920,
    height: 1080,
    backgroundColor: "#070D17",
  },

  topBar: {
    height: 64,
    paddingHorizontal: 56,
    justifyContent: "center",
  },

  brand: {
    fontSize: 19,
    fontWeight: "800",
    color: "#8FA5BC",
    letterSpacing: 0.8,
  },

  content: {
    alignItems: "center",
    paddingHorizontal: 120,
  },

  eyebrow: {
    marginTop: 60,
    fontSize: 20,
    fontWeight: "900",
    color: "#4FD1FF",
    letterSpacing: 4,
  },

  title: {
    marginTop: 10,
    fontSize: 84,
    lineHeight: 88,
    fontWeight: "900",
    color: "#F4F8FC",
    letterSpacing: -1.5,
  },

  subtitle: {
    marginTop: 14,
    fontSize: 28,
    color: "#9FB2C6",
  },

  row: {
    flexDirection: "row",
    gap: 28,
    marginTop: 54,
  },

  tile: {
    width: 420,
    minHeight: 260,
    paddingHorizontal: 36,
    paddingVertical: 34,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#0D1626",
    borderWidth: 1,
    borderColor: "#1B2A44",
    borderRadius: 24,
  },

  tilePressed: {
    borderColor: "#4FD1FF",
    opacity: 0.94,
  },

  icon: {
    fontSize: 64,
  },

  label: {
    marginTop: 10,
    fontSize: 32,
    lineHeight: 37,
    fontWeight: "900",
    color: "#F4F8FC",
    textAlign: "center",
  },

  sub: {
    marginTop: 10,
    fontSize: 21,
    color: "#9FB2C6",
    textAlign: "center",
  },

  skip: {
    marginTop: 40,
    paddingVertical: 10,
    paddingHorizontal: 18,
  },

  skipText: {
    fontSize: 23,
    fontWeight: "700",
    color: "#8FA5BC",
  },

  footer: {
    position: "absolute",
    left: 120,
    right: 120,
    bottom: 36,
    alignItems: "center",
  },

  footerText: {
    fontSize: 16,
    color: "#5F7690",
    textAlign: "center",
  },
});

